// Sons de interface sintetizados via Web Audio (sem arquivos): curtos, baixos e sem bloquear a interação.
const KEY = "ga_ui_sounds";
let ctx = null;
let lastAt = 0;
const listeners = new Set();

export const uiSoundsEnabled = () => localStorage.getItem(KEY) !== "off";
export function setUiSounds(on) {
  localStorage.setItem(KEY, on ? "on" : "off");
  listeners.forEach((fn) => fn(on));
}
export const onUiSoundsChange = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

function getCtx() {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC({ latencyHint: "interactive" });
  if (ctx.state === "suspended") ctx.resume().catch(() => {});
  return ctx;
}

// Pré-aquece o contexto no primeiro gesto do usuário (exigência de autoplay).
export function primeUiSounds() {
  const warm = () => { getCtx(); window.removeEventListener("pointerdown", warm); window.removeEventListener("keydown", warm); };
  window.addEventListener("pointerdown", warm, { passive: true });
  window.addEventListener("keydown", warm);
}

function tone(ac, { freq, to = freq, start, dur, gain, type = "sine" }) {
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, start);
  if (to !== freq) osc.frequency.exponentialRampToValueAtTime(to, start + dur);
  g.gain.setValueAtTime(0.0001, start);
  g.gain.exponentialRampToValueAtTime(gain, start + 0.004);
  g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  osc.connect(g).connect(ac.destination);
  osc.start(start);
  osc.stop(start + dur + 0.01);
}

const PATTERNS = {
  tap: (ac, t) => tone(ac, { freq: 1400, to: 1100, start: t, dur: 0.03, gain: 0.05 }),
  success: (ac, t) => { tone(ac, { freq: 880, start: t, dur: 0.045, gain: 0.05 }); tone(ac, { freq: 1320, start: t + 0.04, dur: 0.06, gain: 0.05 }); },
  error: (ac, t) => tone(ac, { freq: 300, to: 220, start: t, dur: 0.07, gain: 0.06, type: "triangle" }),
};

export function playUiSound(kind = "tap") {
  if (!uiSoundsEnabled()) return;
  const now = performance.now();
  if (now - lastAt < 40) return;
  lastAt = now;
  try {
    const ac = getCtx();
    if (!ac || ac.state !== "running") return;
    (PATTERNS[kind] || PATTERNS.tap)(ac, ac.currentTime);
  } catch (_) { /* nunca bloquear a interação por causa do som */ }
}

export const playTap = () => playUiSound("tap");
export const playSuccess = () => playUiSound("success");
export const playError = () => playUiSound("error");
